import React from "react";
import ZoomOutMap from "@mui/icons-material/ZoomOutMap";

// The one icon for every side panel's "Open full view" control
// (GlobalSidePanel and the screens that still render their own header):
// four arrows pointing out to the corners. Change it here and every panel
// follows.
export const OpenFullViewIcon = (props) => <ZoomOutMap {...props} />;
